export default __webpack_public_path__ + "static/social-follow-de7261f60aee8e47016870c67910e6c1.png";